import withLocalLoader from 'components/HOCs/withLocalLoader';
import { connect } from 'react-redux';
import DashboardCustomers from './DashboardCustomers';
import {
  getAppointmentsViewData,
  createAppointmentRequest
} from 'state/actions/actions';

function mapStateToProps({ appointments, user }) {
  return {
    carriers: appointments.carriers,
    user: user.zohoData
  };
}

export default connect(mapStateToProps, {
  getAppointmentsViewData,
  createAppointmentRequest
})(withLocalLoader(DashboardCustomers, false, 'Customers', 'Customers'));
